import { CartesianChart } from "./CartesianChart";
import type {
  BarChartSpec,
  ChartInteraction,
  ChartMask,
  ChartVariant,
} from "./types";

/** Categorical bar chart (grouped or stacked when `spec.stacked` is set). */
export function BarChart({
  spec,
  variant,
  mask,
  ...interaction
}: {
  spec: BarChartSpec;
  variant: ChartVariant;
  mask?: ChartMask;
} & ChartInteraction) {
  return <CartesianChart spec={spec} variant={variant} mask={mask} {...interaction} />;
}
